import axios from 'axios';
import moment from 'moment/moment';
import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { FiEye, FiEdit, FiTrash } from 'react-icons/fi';
import { AiOutlineFundView } from 'react-icons/ai';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { api, endpoint } from '../../api';
import { userRole } from '../../constant';
import { Spin } from 'antd';
import appConfig from '../../appConfig';

const DeviceList = () => {
  const [totalRow, setTotalRow] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const userDetails = useSelector((state) => state?.user?.userDetails);
  const [devices, setDevices] = useState([]);

  const getDevices = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(endpoint.get_devices, {
        params: { limit, page, sortBy: 'createdAt', orderBy: 'DESC' },
      });
      setDevices(response?.results);
      setTotalRow(response?.count);
    } catch (error) {}
    setIsLoading(false);
    return;
  };

  const columns = [
    {
      name: 'No.',
      cell: (_, index) => <div>{(page - 1) * limit + index + 1}</div>,
      selector: (row) => console.log(row),
      width: '60px',
      center: true,
    },
    {
      name: 'Device Name',
      selector: (row) => row?.name,
    },
    {
      name: 'Device Type',
      cell: (row) => <div className="text-wrap">{row?.deviceType?.name}</div>,
      selector: (row) => row.deviceType,
    },
    {
      name: 'Site Name',
      cell: (row) => <div className="text-wrap">{row?.site?.name}</div>,
      selector: (row) => row.site,
    },
    {
      name: 'Date Installed',
      selector: (row) => moment(row.createdAt).format('DD/MM/YYYY'),
      center: true,
    },
    {
      name: 'Action',
      cell: (row) => (
        <div>
          {(() => {
            switch (userDetails.role) {
              case 'superAdmin':
                return (
                  <div className="actions">
                    <Link to={`/devices/details/` + row._id} className="btn btn-success me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-info me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                    <button className="btn btn-danger" onClick={() => deleteDevice(row._id)}>
                      <FiTrash />
                    </button>
                  </div>
                );
              case 'installer':
                return (
                  <div className="actions">
                    <Link to={`/devices/details/` + row._id} className="btn btn-success me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-info me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                  </div>
                );
              case 'admin':
                return (
                  <div className="actions">
                    <Link to={`/devices/details/` + row._id} className="btn btn-success me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-info me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                  </div>
                );
              case 'user':
                return (
                  <div className="actions">
                    <Link to={`/devices/details/` + row._id} className="btn btn-success me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                  </div>
                );
              case 'public':
                return (
                  <div className="actions">
                    <Link to={`/devices/details/` + row._id} className="btn btn-success me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                  </div>
                );
              default:
                return;
            }
          })()}
        </div>
      ),
      center: 'yes',
      width: '220px',
    },
  ];
  useEffect(() => {
    document.title = `${appConfig.name} - All Devices`;
    getDevices();
    // eslint-disable-next-line
  }, [limit, page]);

  const deleteDevice = async (deviceId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this device?',
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${process.env.REACT_APP_API_URL}/device/` + deviceId, {
            withCredentials: true,
          })
          .then((res) => {
            getDevices();
            Swal.fire({
              title: 'Done!',
              text: 'Device Deleted infofully',
              icon: 'info',
              timer: 2000,
              button: false,
            });
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  };
  return (
    <div className="card p-3 m-3">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <label className="az-content-label">Manage Devices</label>
          <span className="d-block py-2">All Devices</span>
        </div>
        <div className="col-md-4 d-flex justify-content-end p-0 gap-2">
          <Link className="btn btn-danger btn-md" to="/device-csv-upload">
            Bulk CSV Upload
          </Link>
          <Link className="btn btn-az-primary btn-md" to="/add-devices">
            Add New Device
          </Link>
        </div>
      </div>

      <hr className="mt-0" />

      {/* <div className="row">
        <div className="col-md-6">
          <h3>All Devices</h3>
        </div>
        <div className="col-md-6">
          <Link to="/" className="btn btn-successecondary float-end">
            Back
          </Link>
        </div>
      </div> */}
      <Spin spinning={isLoading}>
        <DataTable
          columns={columns}
          data={devices}
          noDataComponent={isLoading ? 'Loading' : 'No record found.'}
          pagination
          paginationServer
          paginationTotalRows={totalRow}
          paginationPerPage={limit}
          onChangePage={(data) => {
            setPage(data);
          }}
          onChangeRowsPerPage={(data) => {
            setLimit(data);
            setPage(1);
          }}
          paginationRowsPerPageOptions={[10, 20, 50]}
        />
      </Spin>
    </div>
  );
};

export default DeviceList;
